import React from 'react';
import PropTypes from 'prop-types';

const BondType = ({ data }) => {
  let displayText = "";
  switch (data){
    case 1:
      displayText = "Jafnar afborganir (Annuitet)";
      break;
    case 2:
      displayText = "Jafnar greiðslur";
      break;
    case 3:
      displayText = "Óreglulegar afborganir";
      break;
    case 10:
      displayText = "Jafngreiðslulán RB (Annuitet) ";
      break;
    default:
      displayText = "Ekki þekkt tegund";
      break;
  }
  return (
    <span>{displayText}</span>
  );
};

BondType.propTypes = {
    data: PropTypes.number,
};

export default BondType;
